<template>
    <DelayHydration>
        <nav
            class="navigation-bar"
            v-bind="$attrs"
        >
            <div class="navigation-bar__inner">
                <div
                    id="navigation-bar__left"
                    class="navigation-bar__left"
                >
                    <slot name="left" />
                </div>
                <div
                    id="navigation-bar__right"
                    class="navigation-bar__right"
                >
                    <slot name="right" />
                </div>
            </div>

            <TheBanner />
        </nav>
    </DelayHydration>
</template>

<script setup>
defineProps({
    staticPosition: {
        type: Boolean,
        default: false
    }
});
</script>

<style lang="less" src="./TheNavBar.less"></style>
